import type { TOC } from '@ember/component/template-only';
import { Footer, Modal } from 'tio-ui/components/modal';

export interface PdfModalSignature {
  Args: {
    show: boolean;
    onClose: () => void;
    closeButtonText?: string;
  };
  Blocks: {
    default: [];
  };
}

const TioPdfModal: TOC<PdfModalSignature> = <template>
  <Modal
    @isOpen={{@show}}
    @onClose={{@onClose}}
    class="min-h-64"
    @backdrop="faded"
    @size="full"
    as |m|
  >
    <m.Body>
      {{yield}}
    </m.Body>
    <m.Footer>
      <Footer
        @isRunning={{false}}
        @onSubmit={{@onClose}}
        @submitText={{if @closeButtonText @closeButtonText "Close Preview"}}
      />
    </m.Footer>
  </Modal>
</template>;

export default TioPdfModal;
